//
// NumericConstraint.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AbstractValueConstraintType";
import "../values/ValueBehavior";
import "../../promptDefinitions/PromptDefinition";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataUsage";

var NumericConstraint = createModule("BIRD::NumericConstraint", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::AbstractConstraintType","BIRD::AbstractValueConstraintType"], EventDispatcher, [
    ,
    {
        minValueRef: 1,
        maxValueRef: 1,
        minBehavior: 4,
        integerOnly: 2,
        maxBehavior: 4,
        maxDigits: 4,
    },
    ,
    ,
    {
        getDataUsage: [4],
    },
    {
        _create: [4],
    },
    ,
]);
export default NumericConstraint;
